module.exports = __webpack_public_path__ + "r-v3/img/logo_loading.75e09011.svg";